import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useI18n } from "i18n";

const Page = () => {
  const { t } = useI18n();

  return (
    <React.Fragment>
      <Box>
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Typography
            variant="h1"
            gutterBottom
            sx={{ fontSize: "24px", fontWeight: "bold", mb: 4 }}
          >
            {t("notFound.title")}
          </Typography>
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default Page;
